// extracted by mini-css-extract-plugin
export default {"link":"AuthNav_link__1DYPd","linkActive":"AuthNav_linkActive__DPbZG AuthNav_link__1DYPd"};